import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

import Icon from "@/components/Icon"
import { Badge } from "@/components/ui/badge"

import { Priority } from "./types"

interface PriorityItemProps {
  priority: Priority
  index: number
}

const PriorityItem = ({ priority, index }: PriorityItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: priority.key,
  })

  const style = {
    transform: transform ? CSS.Transform.toString({ ...transform, x: 0 }) : undefined,
    transition,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex cursor-grab touch-none items-center gap-3 rounded-lg border border-palette-jungleGreen200 bg-white px-3 py-3 active:cursor-grabbing ${isDragging ? "z-10 shadow-md opacity-90" : ""}`}
      {...attributes}
      {...listeners}
    >
      <Icon name="sixDots" className="h-4 w-4 text-palette-jungleGreen900" />

      <Badge className="flex h-6 w-6 shrink-0 items-center justify-center border-none bg-palette-honeycomb200 text-xs font-bold text-palette-honeycomb900 hover:bg-palette-honeycomb200">
        {index + 1}
      </Badge>

      <span className="flex-1 text-sm font-medium text-palette-jungleGreen900">
        {priority.label}
      </span>

      <span className="text-sm text-palette-jungleGreen600">Pool: {priority.pool}</span>
    </div>
  )
}

export default PriorityItem
